import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { consumeReturnSlot } from "../../lib/bflowPostCall";

/*
 * BflowReturnGuard — A/B variant B: app kill hone ke baad user ko wapas
 * /agent-live pe le aata hai.
 *
 * SCENARIO: user dialer kholta hai, call karta hai, aur app band kar deta hai
 * (ya native shell use maar deti hai). Dobara kholne par wo normal boot routing
 * se /fast-agent-detail ya /dashboard pe pahunch jaata tha — flow beech me hi
 * chhoot jaata, aur us call ka "Call captured" card usne kabhi dekha hi nahi.
 *
 * RULE — ek hi "doosra mauka":
 *   pehla cold boot  → wapas /agent-live
 *   doosra cold boot → marker clear, normal routing (dashboard)
 * Ye ginti consumeReturnSlot() sambhalta hai.
 *
 * SIRF tab jab user ne DIALER KHOLA ho. Jo screen dekh kar bina dial kiye nikla,
 * usne kuch shuru hi nahi kiya — usse wapas kheenchna galat hai.
 *
 * NOTE: "app kill hua" detect ho hi nahi sakta; jo dikhta hai wo cold boot hai.
 * Browser refresh bhi wahi cold boot hai, isliye refresh bhi ek return gina
 * jaata hai — maana hua trade-off.
 */

// Redirect SIRF in landing paths se hota hai. Deep links — payment success,
// OAuth callback, email link — kabhi hijack nahi hone chahiye, warna user apni
// asli manzil ke bajaye is flow me pahunch jayega.
const BOOT_PATHS = ["/", "/fast-agent-detail", "/dashboard"];

const BflowReturnGuard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Boot pe sirf EK baar — warna har render/route change pe chalega.
    const checkedRef = useRef(false);

    useEffect(() => {
        if (checkedRef.current) return;

        // Logged-in na ho to chhedo mat — warna login redirect se ladega.
        let token = null;
        try {
            token = localStorage.getItem("token");
        } catch {
            /* storage blocked */
        }
        if (!token) return;

        // Boot abhi kisi aur (deep-link) path pe hai — is boot me kuch nahi.
        if (!BOOT_PATHS.includes(location.pathname)) {
            checkedRef.current = true;
            return;
        }

        checkedRef.current = true;
        const agentId = consumeReturnSlot();
        if (!agentId) return; // dialer khola hi nahi tha, ya mauka khatam

        try {
            sessionStorage.setItem("SelectAgentId", agentId);
        } catch {
            /* ignore */
        }
        navigate("/agent-live", { replace: true });
    }, [location.pathname, navigate]);

    return null;
};

export default BflowReturnGuard;
